module.exports = __webpack_public_path__ + "img/RebeccaAugust.f26a5231.jpg";